import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=937c0ff0&scoped=true&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"
import style0 from "./logo.vue?vue&type=style&index=0&id=937c0ff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937c0ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
